import { IDesignerViewState } from './IDesignerViewState';
import { PayloadAction } from '@reduxjs/toolkit';

export function showCopyDesignModalReducer(
  state: IDesignerViewState,
  action: PayloadAction<boolean>,
) {
  state.showCopyDesignModal = action.payload;
}
